import { Route } from '@angular/router';
import { NotFoundPageComponent } from '@mapa/ngx';
import { PUBLIC_ROUTES } from '../public/routes';

export const appRoutes: Route[] = [
  ...PUBLIC_ROUTES,
  {
    path: '**',
    loadComponent: () => NotFoundPageComponent,
    data: {
      minimalUi: true
    }
  }
];
